import Chat from './ChatContainer';

export default Chat;
